import { render, staticRenderFns } from "./home-table-desktop.vue?vue&type=template&id=5ed33d76&"
import script from "./home-table-desktop.vue?vue&type=script&lang=ts&"
export * from "./home-table-desktop.vue?vue&type=script&lang=ts&"
import style0 from "./home-table-desktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports